import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Custom URL serializer to preserve/add trailing slashes.
 * Applied globally to all /stock/:id and /etf/:id routes for SEO and consistency.
 */
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
   override parse(url: string): UrlTree {
      if (url && url !== '/') {
         const [path, ...query] = url.split(/[?#]/);
         
         // If path ends with a slash and is not a file, remove it for internal Angular Router matching
         if (path.endsWith('/') && path.length > 1 && !this.isFile(path)) {
            const newPath = path.slice(0, -1);
            const suffix = url.substring(path.length);
            url = newPath + suffix;
         }
      }
      return super.parse(url);
   }

   override serialize(tree: UrlTree): string {
      let url = super.serialize(tree);

      if (!url || url === '/') return url;

      // Extract path before query/fragment
      const [path, ...everythingElse] = url.split(/[?#]/);
      const suffix = url.substring(path.length);

      // Add trailing slash IF:
      // 1. The path doesn't already end in a slash
      // 2. The path is not a file/asset with an extension
      if (!path.endsWith('/') && !this.isFile(path)) {
         return path + '/' + suffix;
      }

      return url;
   }

   private isFile(path: string): boolean {
      if (path.startsWith('/stock/') || path.startsWith('/etf/')) {
         return false;
      }
      // Check if the last segment contains a dot (indicating a file extension)
      const segments = path.split('/');
      const lastSegment = segments[segments.length - 1];
      return lastSegment ? lastSegment.includes('.') : false;
   }
}
